import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { namespaceInstallableContent } from '@next-adapter/installable-runtime/namespace-installable-content.js'
import { renderCoreEmailProviderRenderer } from '@next-adapter/templates/renderers/integration-runtime/render-core-email-provider.js'
import { getActiveEmailProvider } from './get-active-email-provider.js'

export function renderCoreEmailProvider(config: ResolvedBetterstartConfig): string {
  const activeProvider = getActiveEmailProvider(config)
  const providerImport = activeProvider
    ? `import { ${activeProvider.exportName} } from '${activeProvider.importPath}'\n`
    : ''
  const providerBranch = activeProvider
    ? renderCoreEmailProviderRenderer({
        kind: 'renderCoreEmailProviderContentTemplate',
        props: {
          activeProviderExportName: String(activeProvider.exportName)
        }
      })
    : ''

  return namespaceInstallableContent(
    config,
    renderCoreEmailProviderRenderer({
      kind: 'renderCoreEmailProviderGeneratedFunctionTemplate',
      props: {
        providerImport: String(providerImport),
        providerBranch: String(providerBranch)
      }
    })
  )
}
